import React from 'react';
import { KakarikoButtonSmall } from 'library';
import { StyledKakarikoEditingCell } from './styles';
import { IKakarikoEditingCellType } from './types';

export const KakarikoEditingCell = (props: IKakarikoEditingCellType) => {
  const {
    className = '',
    isEditing,
    isUpdated,
    isDisabled,
    handleSaveState,
    handleCancel,
    handleEditingState,
  } = props;

  return (
    <StyledKakarikoEditingCell className={className}>
      {isEditing ? (
        <>
          <KakarikoButtonSmall
            buttonRole="secondary"
            handleClick={handleCancel}
            disabled={isUpdated}
          >
            Cancel
          </KakarikoButtonSmall>

          <KakarikoButtonSmall
            isLoading={isUpdated}
            buttonRole="primary"
            buttonTheme="secondary"
            handleClick={handleSaveState}
            disabled={isDisabled || isUpdated}
          >
            Save
          </KakarikoButtonSmall>
        </>
      ) : (
        <KakarikoButtonSmall
          buttonRole="primary"
          buttonTheme="secondary"
          handleClick={handleEditingState}
        >
          Edit
        </KakarikoButtonSmall>
      )}
    </StyledKakarikoEditingCell>
  );
};

export default KakarikoEditingCell;
